import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EventLandingRoutingModule } from './event-landing-routing.module';
import { EventLandingComponent } from './event-landing.component';
import { PaginationModule } from '@core/layout/pagination/pagination.module';
import { SaleEventComponent } from './sale-event/sale-event.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [SaleEventComponent, EventLandingComponent],
  imports: [
    CommonModule,
    EventLandingRoutingModule,
    FormsModule,
    PaginationModule,
  ],
})
export class EventLandingModule {}
